import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { IGetState, TCardId } from '../../../../../../../../../types/types';
import { EDateType } from '../../../../../../../../../const';
import { cardSetDueDateWithEpics } from '../../../../../../../../../rest/effects/card/card/cardSetDueDateWithEpics';
import { cardSetStartDateWithEpics } from '../../../../../../../../../rest/effects/card/card/cardSetStartDateWithEpics';
import {
    SegmentCardEvent,
    SegmentCardOptions,
    segmentTrackAction
} from '../../../../../../../../../middlewares/segment';
import { SegmentCardType } from '../../../../../../../../../middlewares/segment/trackEntities/cardEvents';

export const onChange = (
    cardId: TCardId,
    date: Date,
    dateType: EDateType,
    source: SegmentCardType,
    onChangeOwn: (type: EDateType, date: number) => void
): ThunkAction => {
    return (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const newDate = date
            ? Math.round(date.getTime() / 1000)
            : null;
        const option = {
            name: SegmentCardOptions.TYPE,
            value: source
        };
        if (date) {
            if (dateType === EDateType.DUE_DATE) {
                dispatch(segmentTrackAction(SegmentCardEvent.DUE_DATE_SELECTED, option));
            } else {
                dispatch(segmentTrackAction(SegmentCardEvent.START_DATE_SELECTED, option));
            }
        } else {
            if (dateType === EDateType.DUE_DATE) {
                dispatch(segmentTrackAction(SegmentCardEvent.CLICKED_CLEAR_DUE_DATE, option));
            } else {
                dispatch(segmentTrackAction(SegmentCardEvent.CLICKED_CLEAR_START_DATE, option));
            }
        }
        if (onChangeOwn) {
            onChangeOwn(dateType, newDate);
        } else {
            return dateType === EDateType.DUE_DATE ?
                dispatch(cardSetDueDateWithEpics(cardId, newDate))
                : dispatch(cardSetStartDateWithEpics(cardId, newDate));
        }
    };
};
